<script>
    import { _ } from "svelte-i18n";
    import UserStore from '../stores/user';
</script>

<div class="border text-center text-[16px] bg-white mb-4 p-2 font-bold">
    <div>{$_('docs.token_msg')}</div>
    <div>{$UserStore.data}</div>
</div>